(function () {
  if (window.__customScrollRevealInit) return;
  window.__customScrollRevealInit = true;

  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('[data-scroll-reveal]').forEach(function (el) {
      el.classList.add('is-in-view');
    });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-in-view');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -5% 0px' });

  function observeAll () {
    document.querySelectorAll('[data-scroll-reveal]:not(.is-in-view)').forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeAll);
  } else {
    observeAll();
  }
})();
